// ------------------------------------------------------------------------------
// name: BaseUploader
// author: mudas
// created: 2024-11-19
// ------------------------------------------------------------------------------

import { RcFile } from 'antd/es/upload/interface';
import { Uploader, ChunkOption } from './types';

export class BaseUploader extends Uploader {
  protected _paused: boolean = false;

  // 是否已暂停上传
  get paused() {
    return this._paused;
  }

  stop() {}

  resume() {}

  upload(file: RcFile, options?: ChunkOption) {}
}
